<div class="booble-backdrop-drawer-right">
  <div class="drawer-rtl-in">
    <div class="drawer-content-lg">
      <div class="row padding-left-32 drawer-header">
        <div class="col-md-11">
          <div class="d-flex flex-column">
            <h2 class="title-modal">
              Confirmar pagamento da ordem no exterior
            </h2>
            <p class="p-text-grey-scale-dark mg-bottom-24">
              Informe os dados e confirme recebimento do pagamento do exterior
            </p>
          </div>
        </div>

        <div class="col-md-1 d-flex justify-content-end mg-top-10">
          <div (click)="closeModal()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>
      </div>
      <div class="modal-dialog-scrollable-general">
        <div class="modal-body h-100">
          <p class="name">Informações do destinatário do recebimento</p>
          <form [formGroup]="formInfo">
            <div class="row">
              <div *ngIf="formInfo?.get('cnpj').value" class="col-md-6">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>CNPJ</mat-label>
                  <input
                    matInput
                    formControlName="cnpj"
                    type="text"
                    class=""
                    name=""
                    mask="AA.AAA.AAA/AAAA-00"
                    [clearIfNotMatch]="false"
                    uppercase
                    autocomplete="off"
                    style="text-transform: uppercase"
                    required
                  />

                  <mat-error
                    class="text-danger"
                    *ngIf="
                      formInfo?.controls['cnpj'].touched &&
                      formInfo?.controls['cnpj'].errors?.required
                    "
                  >
                    CNPJ obrigatório
                  </mat-error>
                </mat-form-field>
              </div>

              <div *ngIf="formInfo?.get('cpf').value" class="col-md-6">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>CPF</mat-label>
                  <input
                    matInput
                    formControlName="cpf"
                    type="text"
                    class=""
                    name=""
                    mask="000.000.000-00"
                    required
                  />

                  <mat-error
                    class="text-danger"
                    *ngIf="
                      formInfo?.controls['cpf'].touched &&
                      formInfo?.controls['cpf'].errors?.required
                    "
                  >
                    CPF obrigatório
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Nome do destinatário</mat-label>
                  <input
                    matInput
                    formControlName="receiverName"
                    type="text"
                    class=""
                    name=""
                    required
                  />
                  <mat-error
                    class="text-danger"
                    *ngIf="
                      formInfo?.controls['receiverName'].touched &&
                      formInfo?.controls['receiverName'].errors?.required
                    "
                  >
                    Nome do destinatário obrigatório
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Moeda</mat-label>
                  <mat-select formControlName="currency">
                    <mat-option *ngFor="let moeda of moedas" [value]="moeda"
                      ><img
                        [src]="moeda.image"
                        width="20px"
                        height="20px"
                      /><span class="ml-2">{{ moeda.description }}</span>
                    </mat-option>
                    <mat-select-trigger>
                      <mat-icon
                        [svgIcon]="formInfoControls?.currency?.value.icon"
                      ></mat-icon
                      ><span class="ml-2">{{
                        formInfoControls?.currency?.value.description
                      }}</span>
                    </mat-select-trigger>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div>
              <p class="name">Informações do pagador</p>
              <div class="row">
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Nome do pagador</mat-label>
                    <input
                      matInput
                      formControlName="senderName"
                      type="text"
                      class=""
                      name=""
                      required
                    />

                    <mat-error
                      class="text-danger"
                      *ngIf="
                        formInfo?.controls['senderName'].touched &&
                        formInfo?.controls['senderName'].errors?.required
                      "
                    >
                      Nome do pagador obrigatório
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>País do pagador</mat-label>
                    <input
                      matInput
                      formControlName="senderCountry"
                      type="text"
                      class=""
                      name=""
                      required
                    />

                    <mat-error
                      class="text-danger"
                      *ngIf="
                        formInfo?.controls['senderCountry'].touched &&
                        formInfo?.controls['senderCountry'].errors?.required
                      "
                    >
                      País do pagador obrigatório
                    </mat-error>
                  </mat-form-field>
                </div>

                <div
                  *ngIf="formInfo?.controls['senderEmail'].value"
                  class="col-md-12"
                >
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>E-mail do pagador</mat-label>
                    <input
                      matInput
                      formControlName="senderEmail"
                      type="text"
                      class=""
                      name=""
                      required
                    />

                    <mat-error
                      class="text-danger"
                      *ngIf="
                        formInfo?.controls['senderEmail'].touched &&
                        formInfo?.controls['senderEmail'].errors?.required
                      "
                    >
                      E-mail do pagador obrigatório
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </form>

          <p class="name">Informações do pagamento no exterior</p>

          <div [formGroup]="formPayment" class="row mt-4 form-bank">
            <div class="col-md-6">
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>Valor recebido</mat-label>
                <input
                  matInput
                  formControlName="amountReceived"
                  type="text"
                  class=""
                  name=""
                  required
                  currencyMask
                  [options]="{
                    prefix: currency?.value + ' ',
                    thousands: '.',
                    decimal: ','
                  }"
                />

                <mat-error
                  class="text-danger"
                  *ngIf="
                    formPayment.controls['amountReceived'].touched &&
                    formPayment.controls['amountReceived'].errors?.required
                  "
                >
                  Valor recebido obrigatório
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>Data do pagamento</mat-label>

                <input
                  matInput
                  formControlName="paymentDate"
                  [matDatepicker]="receiptDatePicker"
                />

                <mat-datepicker-toggle matPrefix [for]="receiptDatePicker">
                </mat-datepicker-toggle>

                <mat-datepicker #receiptDatePicker [startAt]="startDate">
                </mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>Nº da ordem no exterior</mat-label>
                <input
                  matInput
                  formControlName="orderNumber"
                  type="text"
                  class=""
                  name=""
                  required
                />

                <mat-error
                  class="text-danger"
                  *ngIf="
                    formPayment.controls['orderNumber'].touched &&
                    formPayment.controls['orderNumber'].errors?.required
                  "
                >
                  Nº da ordem no exterior obrigatório
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>Banco que recebeu</mat-label>
                <mat-select formControlName="bankName">
                  <ng-container *ngIf="deme$ | async as banks">
                    <mat-option *ngFor="let bank of banks" [value]="bank">{{
                      bank
                    }}</mat-option>
                  </ng-container>
                </mat-select>
                <mat-error
                  class="text-danger"
                  *ngIf="
                    formPayment.controls['bankName'].touched &&
                    formPayment.controls['bankName'].errors?.required
                  "
                >
                  Banco que recebeu obrigatório</mat-error
                >
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer-new" [style.justify-content]="'space-between'">
        <button
          class="stroked-red"
          (click)="cancelOrder(this.boobleModalData)"
          mat-stroked-button
        >
          Cancelar a ordem
        </button>

        <div class="d-flex gap-22">
          <button
            type="button"
            [style.width]="'134px'"
            class="btn-outline-dark btn"
            (click)="closeModal()"
            type="button"
          >
            Voltar
          </button>
          <button
            type="button"
            class="btn-footer btn btn-dark-primary-blue"
            [disabled]="formPayment.invalid || loading"
            (click)="sendConfirm()"
            type="button"
          >
            Confimar
            <span
              class="spinner-border spinner-border-sm"
              *ngIf="loading"
            ></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
